const EscalationMatrixSection = () => {
  return (
   <div className="content-contact contact-us">
      <div className="container">
        
        <div className="grievance-section">
          <div className="grievance-card mt-2">
            <h3 className="section-title">Contact Information</h3>
            <div className="table-responsive">
              <table className="table table-bordered table-striped align-middle grievance-table">
                <thead className="table-primary">
                  <tr>
                    <th scope="col">Sr No</th>
                    <th scope="col">Details of</th>
                    <th scope="col">Contact Person</th>
                    <th scope="col">Address</th>
                    <th scope="col">Contact No.</th>
                    <th scope="col">Email Id</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Customer Care</td>
                    <td>Geetanzalii Rawat</td>
                    <td>Plot no 38, Road no-A27, DLF Phase-1, Gurugram, Haryana-122002</td>
                    <td>0124-4383765</td>
                    <td><a href="mailto:asiaticstock@gmail.com">asiaticstock@gmail.com</a></td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Head of Customer Care</td>
                    <td>Sunil Kumar</td>
                    <td>Plot no 38, Road no-A27, DLF Phase-1, Gurugram, Haryana-122002</td>
                    <td>0124-4383765</td>
                    <td><a href="mailto:asiaticstock@gmail.com">asiaticstock@gmail.com</a></td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Compliance Officer (NSE & BSE)</td>
                    <td>Mr. Virender Singh Rawat</td>
                    <td>Plot no 38, Road no-A27, DLF Phase-1, Gurugram, Haryana-122002</td>
                    <td>9315404265</td>
                    <td><a href="mailto:info.asiaticstock@gmail.com">info.asiaticstock@gmail.com</a></td>
                  </tr>
                  <tr>
                    <th scope="row">4</th>
                    <td>CEO/Director</td>
                    <td>Mr. Harvind Kumar Gupta</td>
                    <td>Plot no 38, Road no-A27, DLF Phase-1, Gurugram, Haryana-122002</td>
                    <td>9810132602</td>
                    <td><a href="mailto:hkgupta.asiatic@gmail.com">hkgupta.asiatic@gmail.com</a></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="grievance-card">
            <h3 className="section-title">Details of Grievance Redressal Mechanism</h3>
            <p className="section-subtitle">Various activities of Stock Brokers with timelines</p>
            <div className="table-responsive">
              <table className="grievance-table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Activities</th>
                    <th>Expected Timelines</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { id: 1, activity: "KYC entered into KRA System and CKYCR", timeline: "3 working days of account opening" },
                    { id: 2, activity: "Client Onboarding", timeline: "Immediate, but not later than one week" },
                    { id: 3, activity: "Order execution", timeline: "Immediate on receipt of order, but not later than the same day" },
                    { id: 4, activity: "Allocation of Unique Client Code", timeline: "Before trading" },
                    { id: 5, activity: "Copy of duly completed Client Registration Documents to clients", timeline: "7 days from the date of upload of Unique Client Code to the Exchange by the trading member" },
                    { id: 6, activity: "Issuance of contract notes", timeline: "24 hours of execution of trades" },
                    { id: 7, activity: "Collection of upfront margin from client", timeline: "Before initiation of trade" },
                    { id: 8, activity: "Issuance of intimations regarding other margin due payments", timeline: "At the end of the T day" },
                    { id: 9, activity: "Settlement of client funds", timeline: "30 days / 90 days for running account Settlement (RAS) as per the preference of client. If consent not given for RAS – within 24 hours of pay-out" },
                    { id: 10, activity: "Statement of Accounts for Funds, Securities and Commodities", timeline: "Weekly basis" },
                    { id: 11, activity: "Issuance of retention statement of funds/commodities", timeline: "5 days from the date of settlement" },
                    { id: 12, activity: "Issuance of Annual Global Statement", timeline: "30 days from the end of the financial year" },
                    { id: 13, activity: "Investor grievances redressal", timeline: "21 calendar days from the receipt of the complaint" }
                  ].map(item => (
                    <tr key={item.id}>
                      <th>{item.id}</th>
                      <td>{item.activity}</td>
                      <td>{item.timeline}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="grievance-card">
            <h3 className="section-title">Dos and DON'Ts for Investors</h3>
            <div className="table-responsive">
              <table className="grievance-table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Dos</th>
                    <th>DON'Ts</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { 
                      id: 1, 
                      dos: "Read all documents and conditions being agreed before signing the account opening form.", 
                      donts: "Do not deal with unregistered stock broker." 
                    },
                    { 
                      id: 2, 
                      dos: "Receive a copy of KYC, copy of account opening documents and Unique Client Code.", 
                      donts: "Do not forget to strike off blanks in your account opening and KYC." 
                    },
                    { 
                      id: 3, 
                      dos: "Read the product / operational framework / timelines related to various Trading and Clearing & Settlement processes.", 
                      donts: "Do not submit an incomplete account opening and KYC form." 
                    },
                    { 
                      id: 4, 
                      dos: "Receive all information about brokerage, fees and other charges levied.", 
                      donts: "Do not forget to inform any change in information linked to trading account and obtain confirmation of updation in the system." 
                    },
                    { 
                      id: 5, 
                      dos: "Register your mobile number and email ID in your trading, demat and bank accounts to get regular alerts on your transactions.", 
                      donts: "Do not transfer funds, for the purposes of trading to anyone other than a stock broker. No payment should be made in name of employee of stock broker." 
                    },
                    { 
                      id: 6, 
                      dos: "If executed, receive a copy of Demat Debit and Pledge Instruction (DDPI) However, DDPI is not a mandatory requirement as per SEBI / Stock Exchanges. Before granting DDPI, carefully examine the scope and implications of powers being granted.", 
                      donts: "Do not ignore any emails / SMSs received with regards to trades done, from the Stock Exchange and raise a concern, if discrepancy is observed." 
                    },
                    { 
                      id: 7, 
                      dos: "Receive contract notes for trades executed, showing transaction price, brokerage, GST and STT/CTT etc. as applicable, separately, within 24 hours of execution of trades.", 
                      donts: "Do not opt for digital contracts, if not familiar with computers." 
                    },
                    { 
                      id: 8, 
                      dos: "Receive funds and securities/ commodities on time, as prescribed by SEBI or exchange from time to time.", 
                      donts: "Do not share trading password." 
                    },
                    { 
                      id: 9, 
                      dos: "Verify details of trades, contract notes and statement of account and approach relevant authority for any discrepancies. Verify trade details on the Exchange websites from the trade verification facility provided by the Exchanges.", 
                      donts: "Do not fall prey to fixed / guaranteed returns schemes." 
                    },
                    { 
                      id: 10, 
                      dos: "Receive statement of accounts periodically. If opted for running account settlement, account has to be settled by the stock broker as per the option given by the client (Monthly or Quarterly).", 
                      donts: "Do not fall prey to fraudsters sending emails and SMSs luring to trade in stocks / securities promising huge profits." 
                    },
                    { 
                      id: 11, 
                      dos: "In case of any grievances, approach stock broker or Stock Exchange or SEBI for getting the same resolved within prescribed timelines.", 
                      donts: "Do not follow herd mentality for investments. Seek expert and professional advice for your investments" 
                    },
                    { 
                      id: 12, 
                      dos: "Retain documents for trading activity as it helps in resolving disputes, if they arise.", 
                      donts: "" 
                    }
                  ].map(item => (
                    <tr key={item.id}>
                      <th>{item.id}</th>
                      <td>{item.dos}</td>
                      <td>{item.donts}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="grievance-card">
            <h3 className="section-title">Grievance Redressal Mechanism</h3>
            <p className="grievance-text">
              <span className="level-tag">Level 1 –</span> Approach the Stock Broker at the designated Investor Grievance e-mail ID of the stock broker.
              The Stock Broker will strive to redress the grievance immediately, but not later than 30 days of the receipt of the grievance.
            </p>
            <p className="grievance-text">
              <span className="level-tag">Level 2 –</span> Approach the Stock Exchange using the grievance mechanism mentioned at the website of the
              respective exchange. Complaints Resolution Process at Stock Exchange explained graphically:
            </p>
            <div className="grievance-image">
              <img src="assets/images/contact/cnt.png" alt="Grievance Redressal Process" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EscalationMatrixSection;
